export interface AnchoredPanelPosition {
  top: number;
  left?: number;
  right?: number;
}

const GAP = 8;

/**
 * Where a fixed-position panel up to `width` px wide sits under its trigger: aligned to the
 * trigger's left or right edge, pulled back so it stays `gutter` px inside the viewport.
 * @param trigger the trigger's bounding rect
 * @param align which edge of the trigger the panel lines up with
 * @param width the panel's widest layout
 * @param viewportWidth `window.innerWidth`
 * @param gutter the margin kept on either side of the viewport
 */
export function anchorBelow(
  trigger: Pick<DOMRect, "bottom" | "left" | "right">,
  align: "left" | "right",
  width: number,
  viewportWidth: number,
  gutter = 16,
): AnchoredPanelPosition {
  const top = trigger.bottom + GAP;
  // Below this the panel would cross the far edge; a viewport narrower than the panel gets the gutter.
  const farthest = viewportWidth - width - gutter;
  return align === "left"
    ? { top, left: Math.max(gutter, Math.min(trigger.left, farthest)) }
    : { top, right: Math.max(gutter, Math.min(viewportWidth - trigger.right, farthest)) };
}
